import { optionalBooleanQuerySchema } from "../protocol/shared.js";
import { spaceAgentStreamPresenceSchema, spaceAgentStreamSnapshotSchema } from "../protocol/agent-stream.js";
import { catchupResponseSchema } from "./catchup-response.js";
import { spaceMembersSnapshotSchema } from "./space-members.js";
import { getSpaceStatusResponseSchema } from "./space-status.js";
import { listSpaceThreadsResponseSchema } from "./space-threads.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-bootstrap.ts
const spaceBootstrapResponseSchema = z$1.strictObject({
	includesAgentReadiness: z$1.boolean().optional(),
	activeAgentStreamPresences: z$1.array(spaceAgentStreamPresenceSchema).optional(),
	activeAgentStreams: z$1.array(spaceAgentStreamSnapshotSchema).optional(),
	status: getSpaceStatusResponseSchema,
	members: spaceMembersSnapshotSchema,
	history: catchupResponseSchema,
	threads: listSpaceThreadsResponseSchema
});
const spaceBootstrapQuerySchema = z$1.strictObject({
	includeAgentReadiness: optionalBooleanQuerySchema,
	includeAgentStreamPresence: optionalBooleanQuerySchema
});
//#endregion
export { spaceBootstrapQuerySchema, spaceBootstrapResponseSchema };

//# sourceMappingURL=space-bootstrap.js.map